import { useContext } from "react";
import flags from "../flags";
import { isToday } from "../functions";
import { languagesList } from "../global";
import Loading from "./Loading";
import AppContext from "../contexts/app-context";

import GoogleDriveLink from "../orders/GoogleDriveLink";
import OrderView from "../tables/instances/newExternals/OrderView";

export default function OrderViewTable({
  rows,
  loading,
  data,
  translatorView,
}) {
  const { setModal,setModal2, modal } = useContext(AppContext);
  const setModalIn = translatorView ? setModal2 : setModal;

  return (
    <table className="reportTable all-stat orders">
      <thead>
        <tr>
          {translatorView ? <></> : <th>ID</th>}
          <th></th>
          <th>Nr</th>
          <th>Przyjęcie</th>
          <th>Jak</th>
          <th style={{ textAlign: "center" }} colSpan={2}>
            Para
          </th>
          <th>Klient i dokumenty</th>
          <th>Str.</th>
          <th>Termin</th>
          <th style={{ textAlign: "right" }}>Cena brutto</th>
          {translatorView ? <></> : <th>Wysyłka</th>}
          <th>Użytk.</th>
          <th>Odbiór</th>
          <th>Przetł.</th>
          {translatorView ? <th>Link</th> : <th>Zapł.</th>}
        </tr>
      </thead>
      {loading ? (
        <Loading />
      ) : rows?.length ? (
        <tbody>
          {data?.map((i, index, arr) => (
            <tr
              className={isToday(new Date(i?.create_date)) ? "today" : ""}
              style={
                new Date() - new Date(i?.create_date) < 1000 * 60 * 15
                  ? {
                      background: "linear-gradient(182deg, #ffffff, #95e15d)",
                    }
                  : {}
              }
              key={i?.day || i?.month || i?.year}
            >
              {translatorView ? (
                <></>
              ) : (
                <td style={{ color: "grey" }}>{i?.id}</td>
              )}
              <td>
                {" "}
                <img
                  src={
                    flags[
                      languagesList.find(
                        (lang) => lang?.code == i?.language_main
                      )?.flagCode
                    ]
                  }
                  width={13}
                />
              </td>
              <td
                style={{ width: "70px", cursor: "pointer" }}
                onClick={() =>
                  setModalIn({
                    show: true,
                    type: "Podgląd zlecenia",
                    width: "screen",
                    content: <OrderView id={i?.id} inModal={true} />,
                  })
                }
              >
                {i?.number_order?.replace(/\//g, ".")}
              </td>
              <td style={{ width: "120px" }}>
                {new Date(i?.create_date)?.toLocaleString("pl-PL", {
                  day: "numeric",
                  year: "numeric",
                  month: "numeric",
                })}
                <span style={{ color: "#0b705e" }}>
                  |
                  {new Date(i?.create_date)?.toLocaleString("pl-PL", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </span>
              </td>
              <td style={{ fontSize: "88%" }}>{i?.receive_methods}</td>

              <td
                style={{
                  textAlign: "right",
                  opacity: i?.language_from === "Pol" ? 0.3 : 1,
                }}
              >
                {i?.language_from?.toUpperCase()}
              </td>
              <td style={{ opacity: i?.language_to === "Pol" ? 0.3 : 1 }}>
                {i?.language_to?.toUpperCase()}
              </td>
              <td title={i?.customers_symbol} style={{ width: "320px" }}>
                <div>
                  <div>{i?.customers_name}</div>
                  <div className="documents">{i?.name}</div>
                </div>
              </td>
              <td>{i?.pages}</td>
              <td style={{ width: "120px" }}>
                {new Date(i?.finish_date)?.toLocaleString("pl-PL", {
                  day: "numeric",
                  year: "numeric",
                  month: "numeric",
                })}
                |
                {new Date(i?.finish_date)?.toLocaleString("pl-PL", {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </td>
              <td style={{ textAlign: "right" }} title={i?.price + " netto"}>
                {i?.price_brutto}
              </td>
              {translatorView ? (
                <></>
              ) : (
                <td title={i?.dispatch_price + " netto"}>
                  {i?.dispatch_price ? (
                    "+" + Math.round(i?.dispatch_price * 1.23 * 100) / 100
                  ) : (
                    <></>
                  )}
                </td>
              )}
              <td>{i?.users_name}</td>
              <td style={{ fontSize: "88%" }}>
                {i?.acceptance_methods_name} {i?.acceptance_methods_name2}
              </td>
              <td title={i?.translators}>
                {i?.chars_done != 0 ? (
                  <span style={{ color: "rgb(20,20,20)", fontSize: translatorView ? "12px" : "10px" }}>
                    {i?.chars_done} zzs
                  </span>
                ) : (
                  <></>
                )}
              </td>
              {translatorView ? (
                <td>
                  <GoogleDriveLink
                    orders={[
                      {
                        ...i,
                        orderNoLangOrLetter: i?.number_order?.replace(
                          /\//g,
                          "."
                        ),
                      },
                    ]}
                  />
                </td>
              ) : (
                <td title={i?.payment_methods_payed_date}>
                  {i?.payment_methods_payed_date !== "0000-00-00 00:00:00"
                    ? "✓"
                    : ""}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      ) : (
        <></>
      )}
    </table>
  );
}
